<template>

  <input-drop-media
    @input="uploadFile">
    </input-drop-media>

</template>

<script>
import InputDropMedia from '@/components/Fields/InputDropMedia'

export default {
  name: 'CandidateAttachUpload',
  components: {
    InputDropMedia
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    uploadFile (medias) {
      this.loading = true

      Promise.all(medias.map((media) => {
        return this.$store
        .dispatch('createCandidateAttach', {
          candidate_id: this.candidate._id,
          job_id: this.selectedJob._id,
          attach_media_id: media
        })
      }))
      .then((attachs) => {
        this.loading = false
        this.$emit('created', attachs)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Attach/CandidateAttachUpload.vue